import { templateDefaultValue } from "@constants/template";
import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import BannerImages from "../../Common/BannerImages";
import LanguageTable from "../../Common/LanguageTable";
import { DeleteModal } from "../../Common/DeleteModal";
import { BannerTable } from "../../Common/BannerTable";
import { templateActions } from "../../templateStore";
import BestProduct from "./BestProduct";
import PreviewCoverPage from "../../Application/AppCoverPage/Preview";
import { useSelector } from "react-redux";

function ApplicationCoverPage({ selectedRows }: any) {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const [isReady, setIsReady] = React.useState(false);
    let schema: any = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    const boutique = schema + "_" + selectedRows[0].shopId;
    const imagePathBannierHead = React.useMemo(
        () => ["Application", "LaindingPage", boutique, "Head", "Bannier"],
        [boutique]
    );
    const imagePathBannierLoyalty = React.useMemo(
        () => ["Application", "LaindingPage", boutique, "Loyalty", "Bannier"],
        [boutique]
    );
    const tabs: TabsType[] = [
        {
            title: t("Header"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerImages
                                dataPath={imagePathBannierHead}
                                title="Advertising Banner"
                                size="(png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <LanguageTable
                            path={[
                                "Application",
                                "LaindingPage",
                                boutique,
                                "Head",
                            ]}
                            fields={[
                                {
                                    key: "Title",
                                    label: "Title",
                                    placeholder: "Enter the Title",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.Application.LaindingPage
                                    .Default.Head
                            }
                            sectionTitle="Title"
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
        {
            title: t("Loyalty section"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerImages
                                dataPath={imagePathBannierLoyalty}
                                title="Advertising Banner"
                                size="(png,jpg,jpeg ou webp)"
                            />
                        </div>

                        <LanguageTable
                            path={[
                                "Application",
                                "LaindingPage",
                                boutique,
                                "Loyalty",
                            ]}
                            fields={[
                                {
                                    key: "Title1",
                                    label: "Title 1",
                                    placeholder: "Enter the Title",
                                },
                                {
                                    key: "Title2",
                                    label: "Title 2",
                                    placeholder: "Enter the Title",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.Application.LaindingPage
                                    .Default.Loyalty
                            }
                            sectionTitle="Title"
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
        {
            title: t("Offers section"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerTable
                                section={"Offres"}
                                path={[
                                    "template",
                                    "Application",
                                    "LaindingPage",
                                    boutique,
                                    "Offres",
                                    "Pubs",
                                ]}
                                redirection={true}
                            />
                        </div>
                        <LanguageTable
                            path={[
                                "Application",
                                "LaindingPage",
                                boutique,
                                "Offres",
                            ]}
                            fields={[
                                {
                                    key: "Title",
                                    label: "Title",
                                    placeholder: "Enter the Title",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.Application.LaindingPage
                                    .Default.Offres
                            }
                            sectionTitle="Title"
                        />
                        <DeleteModal section="Offres" />
                    </section>
                </div>
            ),
            customClassName: "",
        },
        {
            title: t("Best products section"),
            content: (
                <BestProduct
                    shopData={{
                        boutique: boutique,
                        id_franshise: selectedRows[0].id_franshise,
                        shopId: selectedRows[0].shopId,
                    }}
                />
            ),
            customClassName: "",
        },
    ];
    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    React.useEffect(() => {
        const ensureAllPaths = async () => {
            await templateActions.ensurePathExists(
                ["Application", "LaindingPage", boutique],
                {
                    Head: {
                        ...templateDefaultValue.Application.LaindingPage.Default
                            .Head,
                        Bannier: {
                            Url: "",
                            Name: "",
                            Type: "",
                            Extenxion: "",
                        },
                    },
                    Offres: {
                        Pubs: [],
                        ...templateDefaultValue.Application.LaindingPage.Default
                            .Offres,
                    },
                    Loyalty: {
                        ...templateDefaultValue.Application.LaindingPage.Default
                            .Loyalty,
                        Bannier: {
                            Url: "",
                            Name: "",
                            Type: "",
                            Extenxion: "",
                        },
                    },
                    BestProducts: {
                        Products: [],
                        ...templateDefaultValue.Application.LaindingPage.Default
                            .BestProducts,
                    },
                }
            );

            setIsReady(true);
        };

        ensureAllPaths();
    }, [boutique]);

    if (!isReady) return null;
    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "65% " }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => (
                            <NavItem
                                key={index}
                                className={classNames(
                                    "pb-1",
                                    "d-flex align-items-center text-nowrap",
                                    {
                                        "disable-nav-item__clz":
                                            activeTab !== index,
                                    },
                                    element.customClassName
                                )}
                                style={{
                                    cursor: "pointer",
                                    borderBottom:
                                        activeTab === index
                                            ? `${mainColor} 3px solid`
                                            : "",
                                }}
                            >
                                <NavLink
                                    className={classNames("text-dark w-100", {
                                        "active customer-account-menu-nav-link-active__clz":
                                            activeTab === index,
                                        "customer-account-menu-nav-link-disable__clz":
                                            activeTab !== index,
                                    })}
                                    onClick={() => toggleNav(index)}
                                >
                                    <span
                                        className="px-2"
                                        style={{
                                            font:
                                                "normal normal 600 20px/27px Segoe UI",
                                        }}
                                    >
                                        {element.title}
                                    </span>
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => (
                        <TabPane
                            tabId={index}
                            key={index}
                            style={{ height: "90%" }}
                        >
                            {element.content}
                        </TabPane>
                    ))}
                </TabContent>
            </div>
            <div style={{ width: "35%" }}>
                <PreviewCoverPage
                    shopData={{
                        boutique: boutique,
                        BestProduct: true,
                        id_franshise: selectedRows[0].id_franshise,
                        shopId: selectedRows[0].shopId,
                    }}
                />
            </div>
        </div>
    );
}

export default ApplicationCoverPage;
